import { useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import AdobeTextField from "../../../../AdobeAriaLib/AdobeTextField";

interface IFormSelectWrapper {
    value: string
    label: string
    required: boolean
    onChange: Function
    validateRule?: Function,
    validationError?: string,
    className?: string
    autocomplete?: string
    name?: string
    inputType?: string
    register?: UseFormRegisterReturn<string>
}

function getValidationError(
    value: string,
    required: boolean,
    validateRule?: Function,
    validationError?: string | null
): string | null {
    if (required && (value == null || String(value).trim() === "")) {
        return validationError ?? "Required";
    }
    if (validateRule && !validateRule(value)) {
        return validationError ?? "Invalid";
    }
    return null;
}

export default function FormTextInputWrapper({ value, label, required, onChange, validateRule, validationError, className, autocomplete, name, inputType, register }: IFormSelectWrapper) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    if (register) {
        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            register.onBlur(e);
            const val = e.target.value;
            setErrorMessage(getValidationError(val, required, validateRule, validationError));
        };

        return (
            <div className={className ?? ''}>
                <label htmlFor={register.name} className="small margin__bottom--xxxs display--block">
                    {label}{required ? " (required)" : ""}
                </label>
                <input
                    id={register.name}
                    type={inputType ?? "text"}
                    className="form__input"
                    autoComplete={autocomplete}
                    required={required}
                    {...register}
                    onBlur={handleBlur}
                />
                {errorMessage && <div className="form__field-error" role="alert">{errorMessage}</div>}
            </div>
        );
    }

    function handleChange(val: string) {
        onChange(val)
    }

    function isDisabled() {
        return false
    }

    return (
        <AdobeTextField
            value={value ?? ''}
            onChangeText={handleChange}
            label={label}
            visibleLabel={true}
            required={required}
            className={className ?? ''}
            disabled={isDisabled()}
            EnterKeyPress={() => { }}
            validateRule={validateRule}
            validationError={validationError}
            autocomplete={autocomplete}
            name={name}
            type={inputType} />
    )
}